/**
 * Utilitários de detecção de plataforma.
 * Permite que o app funcione tanto como web quanto como desktop (NeutralinoJS).
 */

/** Retorna true se o app está rodando dentro do NeutralinoJS */
export function isDesktop(): boolean {
  return '__neutralino_globals' in window;
}

/** Retorna true se o app está rodando no navegador */
export function isWeb(): boolean {
  return !isDesktop();
}

/**
 * Inicializa a API nativa do Neutralino quando em modo desktop.
 * Deve ser chamado uma vez na raiz do app.
 */
export async function inicializarDesktop(): Promise<void> {
  if (!isDesktop()) return;

  try {
    const Neutralino = await import('@neutralinojs/lib');
    Neutralino.init();

    // Encerra o processo ao fechar a janela
    Neutralino.events.on('windowClose', () => {
      Neutralino.app.exit();
    });
  } catch {
    // Falha silenciosa — app continua funcionando como web
  }
}
